import gql from 'graphql-tag';

export const updateApplication = gql`
  mutation updateActiveApplication($payload: JSON!) {
    updateActiveApplication(payLoad: $payload) {
      applicationId
      applicationType
      applicationStatus
      metaData {
        quoteId
        customerOptions
        costsWeekly
        quoteUpload
        hrApprovalRequestSent
        creditCheckCompleted
      }
    }
  }
`;

export const getApplication = gql`
  query getActiveApplication {
    getActiveApplication {
      applicationId
      applicationType
      applicationStatus
      metaData {
        quoteId
        customerOptions
        costsWeekly
        quoteUpload
        hrApprovalRequestSent
        creditCheckCompleted
      }
    }
  }
`;

export const sendHRApproval = gql`
  mutation hrApproval {
    hrApproval {
      status
    }
  }
`;

export const clearApplication = gql`
  mutation clearActiveApplication {
    clearActiveApplication {
      status
    }
  }
`;
